import { Tab, Tabs } from '@material-ui/core';
import { Link, useHistory } from 'react-router-dom';

// local imports
import { Breadcrumb } from 'app/components/atoms';
import FusePageCarded from '@fuse/core/FusePageCarded';
import EndUserList from './customer-list';
import ContactUs from './contact-us/contact-us';

const ROUTES = ['customer-list', 'customer-contact-us'];

const ContentToolbar = ({ tabsVal }) => (
  <Tabs
    selectionFollowsFocus
    value={tabsVal}
    indicatorColor="primary"
    textColor="primary"
    variant="fullWidth"
    scrollButtons="off"
    className="w-full h-64">
    <Tab
      disableFocusRipple
      disableRipple
      value={ROUTES[0]}
      className="h-64 text-15 font-semibold tracking-wide"
      label="Müşteri Listesi"
      role="button"
      component={Link}
      to={ROUTES[0]}
    />
    <Tab
      disableFocusRipple
      disableRipple
      value={ROUTES[1]}
      className="h-64 text-15 font-semibold tracking-wide"
      label="Bize Ulaş - Öneri"
      component={Link}
      role="button"
      to={ROUTES[1]}
    />
  </Tabs>
);

const Content = ({ selectedTab }) => (
  <div className="p-24">
    {selectedTab === ROUTES[0] && <EndUserList />}
    {selectedTab === ROUTES[1] && <ContactUs />}
  </div>
);

const CustomerPageWrapper = () => {
  const history = useHistory();
  const selectedTab = history?.location?.pathname.split('/').pop();
  const tabsVal = selectedTab ? selectedTab : false;

  return (
    <>
      <FusePageCarded
        header={<Breadcrumb title="Müşteri Yönetimi" />}
        contentToolbar={<ContentToolbar tabsVal={tabsVal} />}
        content={<Content selectedTab={selectedTab} />}
      />
    </>
  );
};

export default CustomerPageWrapper;
